/**
 * How far through the unlock celebration a single tier's node has got.
 *
 * This exists because the spec's beats do **not** line up with the tier's data state. By the time the
 * cart response has landed, `tier.state` already says `Unlocked` — but the node is not supposed to
 * look unlocked yet: it holds its locked appearance until 1,200ms, turns magenta while *still showing
 * its reward icon*, and only swaps to the checkmark at 1,800ms. That middle step is a visual state the
 * tracker had no way to express, and without it the whole celebration collapses into one instant flip
 * at t=0.
 *
 * Only one tier celebrates per sequence — a multi-tier crossing celebrates the last reward unlocked
 * (business ruling 2026-08-05) — so the tracker takes a single tier id plus one of these, rather than
 * a per-tier map.
 */
export enum RewardCelebrationStage {
  /** No sequence running. Every tier renders from its own `state`, as it always has. */
  None = 'none',
  /** Sequence started, node beat not yet reached: the celebrating tier still looks locked. */
  Pending = 'pending',
  /** 1,200ms — magenta background and glow, reward icon retained, label still grey. */
  Magenta = 'magenta',
  /** 1,800ms — checkmark with the scale pop, glow intensified, label pink. The resting unlocked look. */
  Checked = 'checked'
}
